import { Link } from '@tanstack/react-router'
import type { AppLanguageCode } from '@/lib/i18n'
import { createSiteTranslate } from '../-lib/site-i18n'
import { SiteLogo } from './site-logo'

export function SiteFooter(props: { appLanguage: AppLanguageCode }) {
	const t = createSiteTranslate(props.appLanguage)

	return (
		<footer className='footer'>
			<div className='wrap'>
				<div className='foot-grid'>
					<div className='foot-brand'>
						<SiteLogo />
						<p>{t('site:footer.tagline')}</p>
					</div>
					<div className='foot-col'>
						<h4>{t('site:footer.product')}</h4>
						<Link hash='come-funziona' to='/'>
							{t('site:footer.how')}
						</Link>
						<Link hash='funzionalita' to='/'>
							{t('site:footer.features')}
						</Link>
						<Link to='/scanner'>{t('site:footer.scanner')}</Link>
						<Link to='/deck-builder'>
							{t('site:footer.deck_builder')}
						</Link>
						<Link to='/collection-tracker'>
							{t('site:footer.collection_tracker')}
						</Link>
						<Link to='/changelog'>{t('site:footer.news')}</Link>
					</div>
					<div className='foot-col'>
						<h4>{t('site:footer.support')}</h4>
						<Link to='/support'>{t('site:footer.contact')}</Link>
						<Link hash='faq' to='/'>
							{t('site:footer.faq')}
						</Link>
						<Link to='/changelog'>
							{t('site:footer.changelog')}
						</Link>
					</div>
					<div className='foot-col'>
						<h4>{t('site:footer.legal')}</h4>
						<Link to='/terms'>{t('site:footer.terms')}</Link>
						<Link to='/privacy'>{t('site:footer.privacy')}</Link>
					</div>
				</div>
				<div className='disclaimer'>
					<strong>{t('site:footer.disclaimer_label')}</strong>{' '}
					{t('site:footer.disclaimer')}
				</div>
				<div className='foot-bottom'>
					<small>{t('site:footer.copyright')}</small>
					<small>{t('site:footer.made_with')}</small>
				</div>
			</div>
		</footer>
	)
}
